<template>
  <div class="community_m" id="wrapper">
    <div id="land">
      <div class="bg"></div>
    </div>
    <Header
      :lang="lang"
      :down="down"
      :list="agreement"
      @chose="choseLanguageFn"
    ></Header>
    <div class="contentOne">
      <!-- <img class="firstImg" src="../assets/images/community-1.png" alt="" /> -->
      <div class="title">
        <div class="box">
          <span class="text">{{ $t("message.strid14") }}</span>
          <span class="text2">{{ $t("message.strid14") }}</span>
        </div>
      </div>
      <div class="imgBox">
        <div
          class="item"
          :class="
            index <= 3 || index > 10
              ? 'lineOne'
              : 4 <= index && index < 7
              ? 'lineTwo'
              : index == 10
              ? 'more'
              : ''
          "
          v-for="(i, index) in fan_works"
          :key="index"
           v-lazy:background-image="{ src: i.img + '&imageslim' }"
          
          @click="bigImg(i.img + '&imageslim')"
        >
          <a class="more" :href="fanBtn" target="_blank" v-if="index == 10">{{
            $t("message.strid8")
          }}</a>
        </div>
      </div>
    </div>
    <!-- src="http://img.haihu.com/01161102914fb7f5262d4f898ad3a6cfc1db35cc.mp4" -->
    <div class="contentTwo">
      <!-- <img class="secondImg" src="../assets/images/community-2.png" alt="" /> -->
      <div class="title">
        <div class="box">
          <span class="text">{{ $t("message.strid15") }}</span>
          <span class="text2">{{ $t("message.strid15") }}</span>
        </div>
      </div>
      <div class="swiper-container contentThreeSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(i, index) in kolList"
            :key="index"
            @click="openVideo(i.url)"
          >
            <div
              class="pic"
              :style="{
                backgroundImage: 'url(' + i.cover + ')',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }"
            >
              <div class="playBtn"></div>
              <div class="info">
                {{ i.title }}
              </div>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <!-- <div class="swiper-pagination"></div> -->
      </div>
      <a :href="kolBtn" target="_blank" class="moreBtn">{{
        $t("message.strid8")
      }}</a>
    </div>
    <div class="creator">
      <img src="../assets/images/community-3.png" alt="" />
      <a
        href="https://creatorcamp.mobilelegends.com/#/"
        target="_blank"
        class="join"
        >{{ $t("message.strid16") }}</a
      >
    </div>
    <div v-if="img" class="mask" @click="img = ''">
      <img :src="img" alt="" />
    </div>
    <Footer @close="closeVideo" :list="iframeSrc"></Footer>
    <IframeViedo
      v-if="showIframe"
      @close="closeVideo"
      :list="iframeSrc"
    ></IframeViedo>
  </div>
</template>

<script>
// import { getList } from "@/proxy/index";
import { mapState } from "vuex";

import { getKol } from "@/proxy/index";

export default {
  props: ["lang"],
  components: {
    Header: () => import("@/components/header"),
    Footer: () => import("@/components/footer"),
    IframeViedo: () => import("@/components/iframeViedo"),
  },
  data() {
    return {
      down: false,
      showIframe: false,
      agreement: [],
      mainSwiper: "",
      galleryThumbs: "",
      galleryTop: "",
      iframeSrc: "https://www.youtube.com/embed/lx6vosPUrHU",
      img: "",
      kolList: [],
      creatorcamp: {},
      channel_id: "",
      num: "",
    };
  },
  computed: {
    ...mapState(["_myData"]),
  },
  watch: {
    _myData: {
      handler(n, o) {
        if (n) {
          const data = n.community;
          this.creatorcamp = data.creatorcamp;
          this.fan_works = data.fan_works.data;
          this.fanBtn = data.fan_works.more;
          this.kolBtn = data.kol.more;
          this.channel_id = data.kol.channel_id;
          this.num = data.kol.num;
          this.getVideo(data.kol.channel_id, data.kol.num);
        }
      },
      immediate: true,
    },
  },
  methods: {
    bigImg(src) {
      this.img = src;
    },
    swiperFn() {
      this.$nextTick(() => {
        this.swiper = new Swiper(".contentThreeSwiper", {
          // slidesPerView: 1.2,
          slidesPerView: "auto",
          spaceBetween: 15,
          loop: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          // centeredSlides: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      });
    },
    openVideo(link) {
      // this.mySwiper.autoplay.stop();
      this.showIframe = true;
      this.iframeSrc = link;
      // "https://www.youtube.com/embed/lx6vosPUrHU"
    },
    closeVideo() {
      this.showIframe = false;
      // this.mySwiper.autoplay.start();
    },
    choseLanguageFn(lan) {
      if (window.localStorage.getItem("GAMElang")) {
        this.swiper.destroy(false);
      }
      this.lang = lan;
      this.$i18n.locale = lan;
      window.localStorage.setItem("GAMElang", this.lang);
      this.getVideo(this.channel_id, this.num);
    },
    getVideo(id, size) {
      getKol({
        channel_id: id,
        producer_id: 0,
        lang: this.$i18n.locale,
        page: 1,
        page_size: size,
        sort: 1,
      }).then((res) => {
        if (res.code == 0) {
          let that = this;
          res.data.list.map((i) => {
            that.kolList.push({
              title: i.title,
              cover: i.thumbnail,
              url: `https://www.youtube.com/embed/${i.key}`,
            });
          });
          this.swiperFn();
        }
      });
    },
  },
  mounted() {
    // this.swiperFn();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/community_m.scss";
</style>